__turbopack_context__.v({
  "form-textarea": "form-textarea-module-scss-module__oKH01W__form-textarea",
  "form-textarea--has-error": "form-textarea-module-scss-module__oKH01W__form-textarea--has-error",
  "form-textarea--has-value": "form-textarea-module-scss-module__oKH01W__form-textarea--has-value",
});
